import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import {
  Box,
  Chip,
  IconButton,
  Skeleton,
  Stack,
  Tooltip,
  Grid,
} from "@mui/material";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { useNavigate } from "react-router-dom";
import Carousel from "../Carousel";

export default function ClassCard(props) {
  const {
    selectedClass,
    loading = false,
    notFoundCode,
    loadFailed = false,
  } = props;
  const navigate = useNavigate();
  const group = selectedClass?.classToGroup?.[0];
  const groupDisplayName =
    (group?.groupDisplayName ?? group?.groupdDsplayName) || "";

  return (
    <Card variant="outlined" sx={{ flexShrink: 0, borderRadius: 2 }}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 7 }}>
            {!selectedClass && !loading ? (
              <Typography color="text.secondary">
                {loadFailed
                  ? "Couldn't load the class. Try refreshing."
                  : notFoundCode
                    ? `Class ${notFoundCode} was not found.`
                    : "Class not found."}
              </Typography>
            ) : !selectedClass ? (
              <>
                <Skeleton variant="text" width="60%" height={32} />
                <Skeleton variant="text" width="90%" />
                <Skeleton variant="text" width="40%" />
              </>
            ) : (
              <>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Chip
                    size="small"
                    color="primary"
                    label={selectedClass.classCode}
                  />
                  <Typography
                    variant="h6"
                    component="h2"
                    sx={{ fontWeight: 600 }}
                  >
                    {selectedClass.classDisplayName}
                  </Typography>
                  <Tooltip
                    title="Edit Class"
                    placement="bottom"
                    enterDelay={300}
                  >
                    <div>
                      <IconButton
                        size="small"
                        aria-label="Edit class"
                        onClick={() => {
                          navigate(`/class/edit/${selectedClass.classCode}`, {
                            state: { row: selectedClass },
                          });
                        }}
                      >
                        <EditNoteIcon />
                      </IconButton>
                    </div>
                  </Tooltip>
                </Stack>
                {selectedClass.classDescription && (
                  <Typography
                    variant="body1"
                    sx={{ mt: 2, color: "text.primary" }}
                  >
                    {selectedClass.classDescription}
                  </Typography>
                )}
                <Box
                  sx={{ mt: 2, display: "flex", alignItems: "center", gap: 1 }}
                >
                  <Typography variant="body2" color="text.secondary">
                    Group:
                  </Typography>
                  <Chip
                    size="small"
                    variant="outlined"
                    label={selectedClass.classGroupCode ?? "Ungrouped"}
                  />
                  {groupDisplayName && (
                    <Typography variant="body2" color="text.secondary">
                      {groupDisplayName}
                    </Typography>
                  )}
                </Box>
              </>
            )}
          </Grid>
          <Grid size={{ xs: 12, md: 5 }}>
            <Carousel
              classCode={selectedClass?.classCode}
              images={selectedClass?.classImages?.split("|") ?? []}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
